import { render } from "./SidebarMenu1.vue?vue&type=template&id=22b91e62&scoped=true"
import script from "./SidebarMenu1.vue?vue&type=script&lang=js"
export * from "./SidebarMenu1.vue?vue&type=script&lang=js"

import "./SidebarMenu1.vue?vue&type=style&index=0&id=22b91e62&lang=scss&scoped=true"

import exportComponent from "../../../../../DIARC/pixonanimation.az/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b91e62"]])

export default __exports__